export function initMenuResponsive() {
	const menuBtn = document.getElementById('responsive-menu-btn');
	const sidebar = document.getElementById('responsive-sidebar-menu');
	const overlay = document.getElementById('sidebar-overlay');
	const body    = document.body;

	if (!menuBtn || !sidebar) return;

	const openSidebar = () => {
		sidebar.classList.add('active');
		body.classList.add('overflow-hidden');
		if (overlay) overlay.classList.add('active');
	};

	const closeSidebar = () => {
		sidebar.classList.remove('active');
		body.classList.remove('overflow-hidden');
		if (overlay) overlay.classList.remove('active');
	};

	menuBtn.addEventListener('click', () => {
		sidebar.classList.contains('active') ? closeSidebar() : openSidebar();
	});

	if (overlay) {
		overlay.addEventListener('click', closeSidebar);
	}

	document.addEventListener('click', (event) => {
		if (
			sidebar.classList.contains('active') &&
			!sidebar.contains(event.target) &&
			!menuBtn.contains(event.target) &&
			!overlay?.contains(event.target)
		) {
			closeSidebar();
		}
	});

	const closeBtn = document.getElementById('sidebar-close-btn');
	if (closeBtn) {
		closeBtn.addEventListener('click', closeSidebar);
	}

	sidebar.addEventListener('click', (e) => {
		if (e.target.closest('a')) {
			closeSidebar();
		}
	});

	document.addEventListener('languageChanged', closeSidebar);
}
